import axios from "axios";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation } from "react-query";
import axiosInstance from "../../utility/axiosInstance";
import { useDispatch } from "react-redux";
import { fetchNotifications } from "../../redux/notificationsThunk";

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { mutate, isSuccess, data } = useMutation({
    mutationKey: ["language"],
    mutationFn: async (lang) => {
      const res = await axiosInstance.post("/admin/changeUserLanguage", {
        language: lang,
      });
      return res;
    },
    onSuccess: (data) => {
      const lang = data?.data?.language;
      i18n.changeLanguage(lang);
      localStorage.setItem("language", lang);
      dispatch(fetchNotifications());
    },
  });
  const changeLanguage = async (lng) => {
    mutate(lng);
  };

  return (
    <div className="language-selector">
      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="p-2 border rounded"
      >
        <option value="en">{t("common.english")}</option>
        <option value="de">{t("common.german")}</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
